import { render, staticRenderFns } from "./LicenseImageCard.vue?vue&type=template&id=551fd606&scoped=true"
import script from "./LicenseImageCard.vue?vue&type=script&lang=js"
export * from "./LicenseImageCard.vue?vue&type=script&lang=js"
import style0 from "./LicenseImageCard.vue?vue&type=style&index=0&id=551fd606&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "551fd606",
  null
  
)

export default component.exports